export default __webpack_public_path__ + "static/media/c3f5121184dd46bf.97a78c99884eef0d93a5baacbb8d03b7.svg";